/** Dedicated ads landing host (GoDaddy A/CNAME). */

export const DEFAULT_TRADE_LANDING_ORIGIN = 'https://perfectpredict.infinity-tech.io'

export const TRADE_LANDING_PATH = '/go/trade'

export const TRADE_LANDING_HOSTS = ['perfectpredict.infinity-tech.io', 'trade.infinity-tech.io'] as const

export const TRADE_LANDING_FOOTER_RISK =
  'Trading involves substantial risk and may result in the loss of capital. No profits are guaranteed.'

export function tradeLandingOrigin(): string {
  const raw = (import.meta.env.VITE_TRADE_LANDING_ORIGIN as string | undefined)?.replace(/\/$/, '')
  return raw || DEFAULT_TRADE_LANDING_ORIGIN
}

export function isTradeLandingHost(hostname = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  const host = hostname.toLowerCase().replace(/^www\./, '')
  if (!host) return false
  try {
    const configured = new URL(tradeLandingOrigin()).hostname.toLowerCase().replace(/^www\./, '')
    if (host === configured) return true
  } catch {
    /* ignore invalid env origin */
  }
  return (TRADE_LANDING_HOSTS as readonly string[]).includes(host)
}

/** YouTube video IDs are 11 characters. Empty / invalid → placeholder, never a random video. */
export function explainerVideoId(): string | undefined {
  const raw = (
    (import.meta.env.VITE_PERFECT_PREDICT_EXPLAINER_VIDEO_ID as string | undefined) ||
    (import.meta.env.VITE_PUBLIC_PERFECT_PREDICT_EXPLAINER_VIDEO_ID as string | undefined) ||
    ''
  ).trim()
  if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw
  return undefined
}

/** Mirror of app.domain.validation email shape (no PII logging). */
export const REGISTER_EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
